import {Column} from 'platform/components';

import i18n from '@dms/i18n';

import {HeaderCell} from './HeaderCell';

export const getPriceListColumns = (formattedTenantCurrency: string): Column[] => [
  {
    element: <HeaderCell isFirst label={i18n.t('general.labels.name')} />,
    width: '20%',
  },
  {
    element: <HeaderCell isFirst label={i18n.t('entity.rental.labels.from')} />,
    width: '5%',
  },
  {
    element: <HeaderCell label={i18n.t('entity.rental.labels.to')} />,
    width: '5%',
  },
  {
    element: <HeaderCell label={i18n.t('entity.rental.labels.period')} />,
    width: '10%',
  },
  {
    element: <HeaderCell label={`${i18n.t('entity.rental.labels.rate')}`} />,
    width: '10%',
  },
  {
    element: (
      <HeaderCell
        label={`${i18n.t('entity.rental.labels.rate')} (${i18n.t('general.labels.withVat')})`}
      />
    ),
    width: '10%',
  },
  {
    element: (
      <HeaderCell
        label={`${formattedTenantCurrency}${i18n.t('entity.rental.labels.ratePerKilometer')}`}
      />
    ),
    width: '10%',
  },
  {
    element: (
      <HeaderCell
        label={`${formattedTenantCurrency}${i18n.t('entity.rental.labels.ratePerKilometer')} ${i18n.t('general.labels.withVat')}`}
      />
    ),
    width: '10%',
  },
  {
    element: <HeaderCell label={i18n.t('entity.rental.labels.includedKilometers')} />,
    width: '10%',
  },
  {
    element: <div></div>,
    width: 10,
  },
];
